import { Component, OnInit, AfterContentInit, Input, Output, EventEmitter } from '@angular/core';
import { WizardStep } from './wizard-step-model';

@Component({
  selector: 'tca-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit, AfterContentInit {
  @Input() stepNames: string[] = [];
  @Input() circleSize = 28;
  @Input() fontSize = 18;
  @Output() wizardStatus: EventEmitter<any> = new EventEmitter();

  steps: WizardStep[] = [];
  currentStep: WizardStep;

  constructor() { }

  private getWizardStatus() {
    return {
      currentStep: this.progressCurrentStep,
      firstStep: this.isFirstStep,
      lastStep: this.isLastStep,
      totalSteps: this.progressTotalSteps
    };
  }

  private emitStatus() {
    this.wizardStatus.emit(this.getWizardStatus());
  }

  ngOnInit() {
    for (const stepName of this.stepNames) {
      this.steps.push({
        name: stepName,
        done: false
      });
    }
    this.currentStep = this.steps[0];
    this.emitStatus();
  }

  ngAfterContentInit() {
  }

  /**
   * Finish each step before the current one
   */
  private updateProgress() {
    this.steps.forEach((step, index) => {
      this.steps[index].done = index < this.currentIndex;
      this.emitStatus();
    });
  }

  /**
   * Go to step
   * @param step next step
   */
  private goToStep(step: WizardStep) {
    this.currentStep = step;
    this.updateProgress();
  }

  /**
   * Index of the current step
   */
  private get currentIndex() {
    return this.steps.indexOf(this.currentStep);
  }

  /**
   * Checks if the step is selected
   */
  public isSelectedStep(step: WizardStep) {
    const index = this.steps.indexOf(step);
    return index === this.currentIndex;
  }

  /**
   * Returns true if a step is done
   */
  stepIsDone(step: WizardStep) {
    return step.done === undefined ? false : step.done;
  }

  onClickStep(step: WizardStep) {
    const index = this.steps.indexOf(step);
    if (index < this.currentIndex) {
      this.goToStep(step);
    }
  }

  get isLastStep() {
    return this.steps.length === this.currentIndex + 1;
  }

  get isFirstStep() {
    return this.currentIndex === 0;
  }

  get progressCurrentStep() {
    return this.currentIndex + 1;
  }

  get progressTotalSteps() {
    return this.steps.length;
  }

  getPixels(n: number) {
    return `${n}px`;
  }

  /**
   * Goes to the next step
   */
  public next() {
    this.wizardStatus = this.wizardStatus;
    if (!this.isLastStep) {
      this.goToStep(this.steps[this.currentIndex + 1]);
    }
  }

  /**
   * Goes to the last step
   */
  public back() {
    this.wizardStatus = this.wizardStatus;
    if (!this.isFirstStep) {
      this.goToStep(this.steps[this.currentIndex - 1]);
    }
  }

}
